// Whether a pointer or the keyboard moved last, kept on `<html data-input>` so app.css can leave out the focus
// ring on a field someone just pressed while keeping it for everyone who moves with Tab. Both listeners capture,
// so a control that stops a press from bubbling still counts.

/** Starts following the last input, and returns the function that stops following it and clears the mark. */
export function startInputModality(document: Document): () => void {
  const root = document.documentElement;
  const pressed = (): void => {
    root.setAttribute('data-input', 'pointer');
  };

  const tabbed = (event: KeyboardEvent): void => {
    if (event.key === 'Tab') {
      root.setAttribute('data-input', 'keyboard');
    }
  };

  document.addEventListener('pointerdown', pressed, true);
  document.addEventListener('keydown', tabbed, true);
  return (): void => {
    document.removeEventListener('pointerdown', pressed, true);
    document.removeEventListener('keydown', tabbed, true);
    root.removeAttribute('data-input');
  };
}
